import React from 'react';
import Auth from '../../../Auth';

const FactoryRoutes = React.lazy(() => import('../../FactoryRoutes'));
const LithoilRoutes = React.lazy(
  () => import('../../../lithoil/LithoilRoutes')
);
const AdminAddonRoutes = React.lazy(
  () => import('../../../addons/Admin/routes')
);
const FlexBIAddonRoutes = React.lazy(
  () => import('../../../addons/FlexiBI/routes')
);
const EmptyRoutes = React.lazy(() => import('./EmptyRoutes'));

interface MainRoutesProps {
  matchUrl: string;
  hasAddons: boolean;
}

const mainRoutes: React.FC<MainRoutesProps> = (props) => {
  const { matchUrl, hasAddons } = props;
  const keyword = Auth.getJWT().addonKeyword;

  let routes;
  if (hasAddons) {
    switch (keyword) {
      case 'adminAddon':
        routes = <AdminAddonRoutes matchUrl={matchUrl} />;
        break;
      case 'flexiBi':
        routes = <FlexBIAddonRoutes matchUrl={matchUrl} />;
        break;
      case 'lithoil':
        routes = <LithoilRoutes matchUrl={matchUrl} />;
        break;
      default:
        routes = <FactoryRoutes matchUrl={matchUrl} />;
        break;
    }
  } else {
    routes = <EmptyRoutes matchUrl={matchUrl} />;
  }

  return (
    <React.Suspense fallback={<div>...</div>}>
      <div>{routes}</div>
    </React.Suspense>
  );
};

export default mainRoutes;
